import React, { useState, useEffect } from 'react';
import { LoginForm } from '../components/LoginForm';
import { SignUpSuccessMessagePlain } from '../components/SignUpSuccessMessagePlain';
import SocialLogin from '../components/SocialLogin';
import MainNavbar from '../components/MainNavbar';
import Footer from '../components/Footer';
import { usePageTitle } from '../lib/usePageTitle';
import { isTokenValid } from '../lib/isTokenValid';
import { SignUpForm } from '../components/SignUpForm';
export default function Home() {
  usePageTitle();
  // Check if user is logged in
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const isLoggedIn = isTokenValid(token);
  // Shared sign-up error state for widget
  const [signupError, setSignupError] = useState<string | string[] | null>(null);
  const [activeTab, setActiveTab] = useState<'login' | 'signup'>('login');
  const [signupSuccess, setSignupSuccess] = useState(false);

  // Clear success message when switching tabs away from login
  useEffect(() => {
    if (activeTab !== 'login' && signupSuccess) {
      setSignupSuccess(false);
    }
  }, [activeTab, signupSuccess]);
  // Login form state and handler
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState<string | null>(null);
  const [loginLoading, setLoginLoading] = useState(false);

  return (
    <div style={{ minHeight: '100vh', width: '100vw', background: '#f8fafc', display: 'flex', flexDirection: 'column', overflowX: 'hidden' }}>
      <MainNavbar />
      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32 }}>
        <div style={{ display: 'flex', width: '100%', maxWidth: 1100, margin: '0 auto', gap: 48, alignItems: 'flex-start' }}>
          {/* Main content, full width if logged in */}
          <div style={{ flex: 1, background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', padding: 40, textAlign: 'center', minWidth: 320, maxWidth: isLoggedIn ? '100%' : undefined }}>
            <h1 style={{ fontSize: 36, fontWeight: 800, marginBottom: 24, color: '#2563eb' }}>MagicFamConcierge</h1>
            <p style={{ fontSize: 20, color: '#222', marginBottom: 32 }}>
              Effortlessly manage your family life and always be the thoughtful one. MagicFamConcierge helps you:
            </p>
            <ul style={{ textAlign: 'left', fontSize: 18, color: '#333', margin: '0 auto 32px', maxWidth: 500, paddingLeft: 20 }}>
              <li style={{ marginBottom: 16 }}>
                <strong>Gift Reminders & Recommendations:</strong> Get smart, personalized gift ideas for every occasion.
                <span style={{ color: '#bbb', fontWeight: 400, marginLeft: 4 }}>
                  Coming Soon: timely reminders delivered right to your inbox.
                </span>
              </li>
              <li style={{ marginBottom: 16, color: '#bbb' }}><strong>Thank-You Card Tracking:</strong> <span style={{ fontWeight: 400 }}>Coming soon</span> — Never forget to send a thank-you—track and automate reminders with ease.</li>
              <li style={{ marginBottom: 16, color: '#bbb' }}><strong>Chore Tracking & Rewards:</strong> <span style={{ fontWeight: 400 }}>Coming soon</span> — Assign chores, send mobile notifications, and motivate with point rewards.</li>
              <li style={{ marginBottom: 16, color: '#bbb' }}><strong>Shared Recipe Book:</strong> <span style={{ fontWeight: 400 }}>Coming soon</span> — Collect family favorites, vote on recipes, and auto-generate shopping lists.</li>
              <li style={{ marginBottom: 16, color: '#bbb' }}><strong>Home Project Planning:</strong> <span style={{ fontWeight: 400 }}>Coming soon</span> — Organize and prioritize home improvement projects by budget, season, or urgency.</li>
            </ul>
            <p style={{ fontSize: 18, color: '#555', marginBottom: 24 }}>
              Your concierge-like hub for making family life easier, more organized, and more fun.
            </p>
          </div>
          {/* Right: Tabbed login/signup widgets */}
          {/* Show tabbed login/signup only if not logged in */}
          {!isLoggedIn && (
            <div style={{ minWidth: 320, maxWidth: 400, width: 400, background: '#f3f4f6', borderRadius: 12, padding: 0, marginLeft: 'auto', marginRight: 'auto', display: 'block', boxSizing: 'border-box' }}>
              <div style={{ display: 'flex', borderBottom: '1px solid #e5e7eb' }}>
                <button
                  onClick={() => setActiveTab('login')}
                  style={{ flex: 1, padding: '14px 0', background: activeTab === 'login' ? '#fff' : 'transparent', border: 'none', borderRadius: '12px 12px 0 0', fontWeight: 700, color: activeTab === 'login' ? '#2563eb' : '#555', fontSize: 18, cursor: 'pointer', boxShadow: activeTab === 'login' ? '0 2px 8px rgba(0,0,0,0.04)' : 'none' }}
                >Login</button>
                <button
                  onClick={() => setActiveTab('signup')}
                  style={{ flex: 1, padding: '14px 0', background: activeTab === 'signup' ? '#fff' : 'transparent', border: 'none', borderRadius: '12px 12px 0 0', fontWeight: 700, color: activeTab === 'signup' ? '#2563eb' : '#555', fontSize: 18, cursor: 'pointer', boxShadow: activeTab === 'signup' ? '0 2px 8px rgba(0,0,0,0.04)' : 'none' }}
                >Signup</button>
              </div>
              <div style={{ padding: 24, background: '#fff', borderRadius: '0 0 12px 12px', width: '100%' }}>
                {activeTab === 'login' ? (
                  <>
                    {signupSuccess && <SignUpSuccessMessagePlain />}
                    <LoginForm
                      error={loginError}
                      setError={setLoginError}
                      loading={loginLoading}
                      setLoading={setLoginLoading}
                      email={loginEmail}
                      setEmail={setLoginEmail}
                      password={loginPassword}
                      setPassword={setLoginPassword}
                      onSuccess={() => {
                        window.location.href = '/dashboard';
                      }}
                    />
                    <SocialLogin onError={setLoginError} />
                  </>
                ) : (
                  <>
                    <SignUpForm error={signupError} setError={setSignupError} setActiveTab={setActiveTab} setSuccess={setSignupSuccess} />
                    <SocialLogin onError={setSignupError} />
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
